import { $timeseries } from "../Plugin";

export function useDataService() {
  return $timeseries;
}
